export default "__VITE_ASSET__eRMRMmrx__"